import { Fragment, ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Trans } from '@lingui/react/macro';

export interface EventMetadataProps {
  data: {
    key: ReactNode;
    value: ReactNode;
  }[];
}

const CONTAINER_NAME = 'event-metadata';

export const EventMetadata = ({ data }: EventMetadataProps) => {
  const isValueEmpty = (value: unknown) => value === null || value === undefined;

  return (
    <Grid
      container
      columnSpacing={2}
      rowSpacing={1}
      border={1}
      borderColor="divider"
      p={2}
      borderRadius={1}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        container: `${CONTAINER_NAME} / inline-size`,
      })}
    >
      {data.map(({ key, value }, idx) => (
        <Fragment key={idx}>
          <Grid size={{ xs: 12, sm: 2, md: 4, lg: 2 }}>
            <Typography variant="body2" color="textSecondary">
              {key}:
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 8, lg: 4 }}>
            <Typography variant="body2" fontWeight={500}>
              {isValueEmpty(value) ? (
                <Typography
                  variant="inherit"
                  color="textDisabled"
                  fontStyle="italic"
                  component="span"
                >
                  <Trans>Unknown</Trans>
                </Typography>
              ) : (
                value
              )}
            </Typography>
          </Grid>
        </Fragment>
      ))}
    </Grid>
  );
};
